"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsMultiSelectWidget = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
var pds = powerSchoolDesignSystemToolkit;
var PdsMultiSelectWidget = (function (_super) {
    __extends(PdsMultiSelectWidget, _super);
    function PdsMultiSelectWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            multiSelect: new pds.models.MultiSelect(_this.cloneMultiSelectData(props.multiSelectData))
        };
        _this.state.multiSelect.selectionChange.subscribe(function (item) {
            props.selectionChange(_this.cloneMultiSelectData(_this.state.multiSelect.multiSelectData));
        });
        return _this;
    }
    PdsMultiSelectWidget.prototype.cloneMultiSelectData = function (multiSelectData) {
        var newSelections = [];
        for (var _i = 0, multiSelectData_1 = multiSelectData; _i < multiSelectData_1.length; _i++) {
            var item = multiSelectData_1[_i];
            newSelections.push({
                id: item.id,
                text: item.text,
                isSelected: item.isSelected
            });
        }
        return newSelections;
    };
    PdsMultiSelectWidget.prototype.componentDidUpdate = function () {
        var sameLength = (this.state.multiSelect.multiSelectData.length === this.props.multiSelectData.length);
        var valuesChanged = false;
        if (sameLength) {
            for (var i = 0; i < this.state.multiSelect.multiSelectData.length; i++) {
                if (this.state.multiSelect.multiSelectData[i].id !== this.props.multiSelectData[i].id ||
                    this.state.multiSelect.multiSelectData[i].text !== this.props.multiSelectData[i].text ||
                    this.state.multiSelect.multiSelectData[i].isSelected !== this.props.multiSelectData[i].isSelected) {
                    valuesChanged = true;
                    break;
                }
            }
        }
        if (!sameLength || valuesChanged) {
            this.state.multiSelect.multiSelectData = this.cloneMultiSelectData(this.props.multiSelectData);
            this.state.multiSelect.selectionChange.next();
        }
    };
    PdsMultiSelectWidget.prototype.render = function () {
        var props = this.props;
        return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-multi-select-widget", attributes: {
                id: react_utils_1.toAttribute(props.id),
                name: react_utils_1.toAttribute(props.name),
                'data-button-text': react_utils_1.toAttribute(props.dataButtonText),
                'data-button-aria-text': react_utils_1.toAttribute(props.dataButtonAriaText),
                'data-label-text': react_utils_1.toAttribute(props.dataLabelText),
                'data-show-label': react_utils_1.toAttribute(props.dataShowLabel),
                'data-badge-text': react_utils_1.toAttribute(props.dataBadgeText),
                'data-tooltip-text': react_utils_1.toAttribute(props.dataTooltipText),
                'data-helper-text': react_utils_1.toAttribute(props.dataHelperText),
                'data-hide-unelevated-badge': react_utils_1.toAttribute(props.dataHideUnelevatedBadge),
                'data-disable-invalid-badge-elevation': react_utils_1.toAttribute(props.dataDisableInvalidBadgeElevation),
                'data-isrequired': react_utils_1.toAttribute(props.dataIsrequired),
                'data-customvalidate': react_utils_1.toAttribute(props.dataCustomvalidate),
                'data-is-field-only': react_utils_1.toAttribute(props.dataIsFieldOnly),
                class: react_utils_1.toAttribute(props.className)
            }, properties: {
                multiSelect: this.state.multiSelect
            }, listeners: {} }));
    };
    return PdsMultiSelectWidget;
}(react_1.default.Component));
exports.PdsMultiSelectWidget = PdsMultiSelectWidget;

//# sourceMappingURL=pds-multi-select-widget.js.map
